import db from 'src/lib/dexie-db/db';
import { NodeType } from 'src/modules/exam-preparation/graphql/common/types/node';
import { getSafeData } from './utils';
const ExamLevelAPIs = {
    async getList(userID, communityID, pagination = { offset: 0 }) {
        const { offset = 0, limit = 20 } = pagination;
        let query = db.qnaNode
            .where('ancestors')
            .equals(communityID)
            .and(node => node.type === NodeType.EXAM_LEVEL && !node.deleted);
        if (pagination) {
            query = query
                .offset(offset)
                .limit(limit);
        }
        const examLevels = await query.toArray();
        // Sort by sequence
        examLevels.sort((a, b) => (a.sequence ?? 0) - (b.sequence ?? 0));
        const totalCount = await db.qnaNode
            .where('ancestors')
            .equals(communityID)
            .and(node => node.type === NodeType.EXAM_LEVEL && !node.deleted)
            .count();
        return {
            list: examLevels.map(getSafeData),
            totalCount,
        };
    },
    async getByID(userID, examLevelID) {
        const examLevel = await db.qnaNode.get(examLevelID);
        if (!examLevel || examLevel.type !== NodeType.EXAM_LEVEL || examLevel.deleted) {
            throw new Error('Exam level not found');
        }
        return getSafeData(examLevel);
    },
    getSafeData,
};
export default ExamLevelAPIs;
